/* eslint-disable no-unused-expressions */
/* eslint-disable no-sequences */
/* eslint-disable no-unreachable */
/* eslint-disable default-case */
/* eslint-disable no-sparse-arrays */
/* eslint-disable no-fallthrough */
"use strict";
var __awaiter =
  (this && this.__awaiter) ||
  function (thisArg, _arguments, P, generator) {
    function adopt(value) {
      return value instanceof P
        ? value
        : new P(function (resolve) {
            resolve(value);
          });
    }
    return new (P || (P = Promise))(function (resolve, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value));
        } catch (e) {
          reject(e);
        }
      }
      function rejected(value) {
        try {
          step(generator["throw"](value));
        } catch (e) {
          reject(e);
        }
      }
      function step(result) {
        result.done
          ? resolve(result.value)
          : adopt(result.value).then(fulfilled, rejected);
      }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
  };
var __generator =
  (this && this.__generator) ||
  function (thisArg, body) {
    var _ = {
        label: 0,
        sent: function () {
          if (t[0] & 1) throw t[1];
          return t[1];
        },
        trys: [],
        ops: [],
      },
      f,
      y,
      t,
      g;
    return (
      (g = { next: verb(0), throw: verb(1), return: verb(2) }),
      typeof Symbol === "function" &&
        (g[Symbol.iterator] = function () {
          return this;
        }),
      g
    );
    function verb(n) {
      return function (v) {
        return step([n, v]);
      };
    }
    function step(op) {
      if (f) throw new TypeError("Generator is already executing.");
      while (_)
        try {
          if (
            ((f = 1),
            y &&
              (t =
                op[0] & 2
                  ? y["return"]
                  : op[0]
                  ? y["throw"] || ((t = y["return"]) && t.call(y), 0)
                  : y.next) &&
              !(t = t.call(y, op[1])).done)
          )
            return t;
          if (((y = 0), t)) op = [op[0] & 2, t.value];
          switch (op[0]) {
            case 0:
            case 1:
              t = op;
              break;
            case 4:
              _.label++;
              return { value: op[1], done: false };
            case 5:
              _.label++;
              y = op[1];
              op = [0];
              continue;
            case 7:
              op = _.ops.pop();
              _.trys.pop();
              continue;
            default:
              if (
                !((t = _.trys), (t = t.length > 0 && t[t.length - 1])) &&
                (op[0] === 6 || op[0] === 2)
              ) {
                _ = 0;
                continue;
              }
              if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                _.label = op[1];
                break;
              }
              if (op[0] === 6 && _.label < t[1]) {
                _.label = t[1];
                t = op;
                break;
              }
              if (t && _.label < t[2]) {
                _.label = t[2];
                _.ops.push(op);
                break;
              }
              if (t[2]) _.ops.pop();
              _.trys.pop();
              continue;
          }
          op = body.call(thisArg, _);
        } catch (e) {
          op = [6, e];
          y = 0;
        } finally {
          f = t = 0;
        }
      if (op[0] & 5) throw op[1];
      return { value: op[0] ? op[1] : void 0, done: true };
    }
  };
var __rest =
  (this && this.__rest) ||
  function (s, e) {
    var t = {};
    for (var p in s)
      if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
      for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (
          e.indexOf(p[i]) < 0 &&
          Object.prototype.propertyIsEnumerable.call(s, p[i])
        )
          t[p[i]] = s[p[i]];
      }
    return t;
  };
exports.__esModule = true;
exports.definirFasePeriodoUsuario =
  exports.atualizarPeriodoUsuario =
  exports.tratamentoValoresInput =
  exports.qualSituacao =
  exports.getCookie =
  exports.setCookie =
  exports.enviarEmail =
  exports.validateTokenEmail =
  exports.validateToken =
  exports.logout =
  exports.formatarDataDayJs =
  exports.adicionarDiasData =
  exports.validateSegundaDataEMaior =
  exports.validatePeriodoFracionado =
  exports.validateDataCheckOutMaior =
  exports.validateData =
  exports.validateDataPeriodo =
  exports.validateCPF =
  exports.validateCelular =
  exports.formatarData =
  exports.exibirDataFuncaoDate =
  exports.formatarDataExibicao =
  exports.exibirMoeda =
  exports.formatarMoeda =
  exports.CalcularDiferencaDias =
  exports.InativarTokenPeriodoUsuario =
  exports.VerificarPeriodo =
  exports.AlterarFormatoData =
    void 0;
var axios_1 = require("axios");
var jwt_decode_1 = require("jwt-decode");
var Globais = /** @class */ (function () {
  function Globais() {}
  //código desenvolvimento
  // static DOMINIOBACK = "http://127.0.0.1:7000";
  // static DOMINIOFRONT = "http://127.0.0.1:3000";
  // static TITULO = "DESENVOLVIMENTO";
  // static DOMINIOFRONT = "http://192.168.0.9:3000";
  // static DOMINIOBACK = "http://10.45.10.99:7000";
  //fim codigo desenvolvimento
  //código testes
  //
  Globais.DOMINIOBACK = "https://www.multicotas.com.br:21001";
  Globais.DOMINIOFRONT = "https://hml.multicotas.com.br";
  Globais.TITULO = "HOMOLOGAÇÃO";
  //fim codigo testes
  //código produção
  // static DOMINIOBACK = "https://www.multicotas.com.br:21000";
  // static DOMINIOFRONT = "https://www.multicotas.com.br";
  // static TITULO = "";
  //fim código produção
  Globais.CorTexto = "#fff";
  // static CorTexto = "#465b73";
  Globais.CorVerde = "#003644";
  // static CorVerde = "#5d7366";
  Globais.CorVermelha = "#d63031";
  Globais.CorVerdeConcluido = "#55efc4";
  Globais.CorAmareloUtilizar = "#feca57";
  Globais.CorAzulBackGround = "#003644";
  // static CorAzulBackGround = "#7e9dbf";
  Globais.CorBege = "#E1B12C";
  return Globais;
})();
exports["default"] = Globais;
function AlterarFormatoData(props) {
  var dates = props.split("/");
  dates.splice(0, 0, dates[1]);
  dates.splice(2, 1);
  return dates.join("-");
}
exports.AlterarFormatoData = AlterarFormatoData;
//verifica se o período do usuário deve receber uma sugestão ou não
function VerificarPeriodo(checkin, status, situacao, fase, dataSugestao) {
  if (
    status === "NAO_PERTUBE" ||
    status === "ALTERANDO" ||
    status === "FINALIZADO"
  ) {
    return "ok";
  } else {
    if (
      situacao === "Alugar" ||
      situacao === "Alugar ou trocar" ||
      situacao === "Não definido"
    ) {
      var hoje = exibirDataFuncaoDate(new Date());
      if (status === "AGUARDANDO_SUGESTAO" || status === "AGUARDANDO_PEDIDO") {
        if (dataSugestao) {
          var tempoSugerido = CalcularDiferencaDias(
            AlterarFormatoData(hoje),
            formatarDataExibicao(dataSugestao)
          );
          if (tempoSugerido > 30) {
            var diferenca = CalcularDiferencaDias(
              AlterarFormatoData(checkin),
              AlterarFormatoData(hoje)
            );
            console.log(checkin, diferenca);
            if (diferenca < 0) {
              return "ok";
            } else {
              if (diferenca > 180) {
                switch (fase) {
                  case "INICIAL":
                    return "Verificar";
                  case "FASE0":
                    return "ok";
                  case "FASE1":
                    return "ok";
                  case "FASE2":
                    return "ok";
                  case "FASE3":
                    return "ok";
                  case "FASE4":
                    return "ok";
                  case "FASE5":
                    return "ok";
                }
              } else {
                if (diferenca > 150) {
                  switch (fase) {
                    case "INICIAL":
                      return "Verificar";
                    case "FASE0":
                      return "Verificar";
                    case "FASE1":
                      return "ok";
                    case "FASE2":
                      return "ok";
                    case "FASE3":
                      return "ok";
                    case "FASE4":
                      return "ok";
                    case "FASE5":
                      return "ok";
                  }
                } else {
                  if (diferenca > 120) {
                    switch (fase) {
                      case "INICIAL":
                        return "Verificar";
                      case "FASE0":
                        return "Verificar";
                      case "FASE1":
                        return "Verificar";
                      case "FASE2":
                        return "ok";
                      case "FASE3":
                        return "ok";
                      case "FASE4":
                        return "ok";
                      case "FASE5":
                        return "ok";
                    }
                  } else {
                    if (diferenca > 90) {
                      switch (fase) {
                        case "INICIAL":
                          return "Verificar";
                        case "FASE0":
                          return "Verificar";
                        case "FASE1":
                          return "Verificar";
                        case "FASE2":
                          return "Verificar";
                        case "FASE3":
                          return "ok";
                        case "FASE4":
                          return "ok";
                        case "FASE5":
                          return "ok";
                      }
                    } else {
                      if (diferenca > 60) {
                        switch (fase) {
                          case "INICIAL":
                            return "Verificar";
                          case "FASE0":
                            return "Verificar";
                          case "FASE1":
                            return "Verificar";
                          case "FASE2":
                            return "Verificar";
                          case "FASE3":
                            return "Verificar";
                          case "FASE4":
                            return "ok";
                          case "FASE5":
                            return "ok";
                        }
                      } else {
                        if (diferenca <= 60) {
                          switch (fase) {
                            case "INICIAL":
                              return "Verificar";
                            case "FASE0":
                              return "Verificar";
                            case "FASE1":
                              return "Verificar";
                            case "FASE2":
                              return "Verificar";
                            case "FASE3":
                              return "Verificar";
                            case "FASE4":
                              return "Verificar";
                            case "FASE5":
                              return "ok";
                          }
                        } else {
                          console.log("Não sei qual a fase");
                        }
                      }
                    }
                  }
                }
              }
            }
          } else {
            return "ok";
          }
        }
      } else {
        var diferenca = CalcularDiferencaDias(
          AlterarFormatoData(checkin),
          AlterarFormatoData(hoje)
        );
        if (diferenca < 0) {
          return "ok";
        } else {
          if (diferenca > 180) {
            switch (fase) {
              case "INICIAL":
                return "Verificar";
              case "FASE0":
                return "ok";
              case "FASE1":
                return "ok";
              case "FASE2":
                return "ok";
              case "FASE3":
                return "ok";
              case "FASE4":
                return "ok";
              case "FASE5":
                return "ok";
            }
          } else {
            if (diferenca > 150) {
              switch (fase) {
                case "INICIAL":
                  return "Verificar";
                case "FASE0":
                  return "Verificar";
                case "FASE1":
                  return "ok";
                case "FASE2":
                  return "ok";
                case "FASE3":
                  return "ok";
                case "FASE4":
                  return "ok";
                case "FASE5":
                  return "ok";
              }
            } else {
              if (diferenca > 120) {
                switch (fase) {
                  case "INICIAL":
                    return "Verificar";
                  case "FASE0":
                    return "Verificar";
                  case "FASE1":
                    return "Verificar";
                  case "FASE2":
                    return "ok";
                  case "FASE3":
                    return "ok";
                  case "FASE4":
                    return "ok";
                  case "FASE5":
                    return "ok";
                }
              } else {
                if (diferenca > 90) {
                  switch (fase) {
                    case "INICIAL":
                      return "Verificar";
                    case "FASE0":
                      return "Verificar";
                    case "FASE1":
                      return "Verificar";
                    case "FASE2":
                      return "Verificar";
                    case "FASE3":
                      return "ok";
                    case "FASE4":
                      return "ok";
                    case "FASE5":
                      return "ok";
                  }
                } else {
                  if (diferenca > 60) {
                    switch (fase) {
                      case "INICIAL":
                        return "Verificar";
                      case "FASE0":
                        return "Verificar";
                      case "FASE1":
                        return "Verificar";
                      case "FASE2":
                        return "Verificar";
                      case "FASE3":
                        return "Verificar";
                      case "FASE4":
                        return "ok";
                      case "FASE5":
                        return "ok";
                    }
                  } else {
                    if (diferenca <= 60) {
                      switch (fase) {
                        case "INICIAL":
                          return "Verificar";
                        case "FASE0":
                          return "Verificar";
                        case "FASE1":
                          return "Verificar";
                        case "FASE2":
                          return "Verificar";
                        case "FASE3":
                          return "Verificar";
                        case "FASE4":
                          return "Verificar";
                        case "FASE5":
                          return "ok";
                      }
                    } else {
                      console.log("Não sei qual a fase");
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      return "ok";
    }
  }
}
exports.VerificarPeriodo = VerificarPeriodo;
function InativarTokenPeriodoUsuario(periodoUsuarioId, token) {
  return __awaiter(this, void 0, void 0, function () {
    var Token, URLToken, responseTokenAlterando, err_1;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          Token = validateToken();
          if (!Token) return [3 /*break*/, 5];
          URLToken =
            Globais.DOMINIOBACK +
            "/auth/validarToken/confirmacaoperiodo/inativarToken/" +
            periodoUsuarioId +
            "/" +
            token;
          _a.label = 1;
        case 1:
          _a.trys.push([1, 3, , 4]);
          return [
            4 /*yield*/,
            axios_1["default"].put(
              URLToken,
              {},
              {
                headers: { Authorization: Token.AuthStr },
              }
            ),
          ];
        case 2:
          responseTokenAlterando = _a.sent();
          if (responseTokenAlterando) {
            return [2 /*return*/, 1];
          }
          return [3 /*break*/, 4];
        case 3:
          err_1 = _a.sent();
          alert("Há algo de errado. Entre em contato conosco.");
          return [2 /*return*/, 2];
        case 4:
          return [3 /*break*/, 6];
        case 5:
          console.log("Não econtrei token");
          _a.label = 6;
        case 6:
          return [2 /*return*/];
      }
    });
  });
}
exports.InativarTokenPeriodoUsuario = InativarTokenPeriodoUsuario;
function CalcularDiferencaDias(dataFim, dataIni) {
  var data2 = dataFim;
  var data1 = dataIni;
  var diffInMs = +new Date(data2) - +new Date(data1);
  // console.log("new Date(data2)");
  // console.log(new Date(data2));
  // console.log("new Date(data1))");
  // console.log(diffInMs);
  var diferenca = diffInMs / (1000 * 60 * 60 * 24);
  return diferenca;
}
exports.CalcularDiferencaDias = CalcularDiferencaDias;
function formatarMoeda(valor) {
  var count = 0;
  var pos = valor.indexOf(",");
  while (pos !== -1) {
    count++;
    pos = valor.indexOf(",", pos + 1 /* o mesmo que 3 + 1 */);
  }
  var iterator = valor[Symbol.iterator]();
  var theChar = iterator.next();
  var NotZero = 0;
  while (!theChar.done && theChar.value != "0") {
    NotZero++;
    theChar = iterator.next();
  }
  if (count > 1) {
    alert("Tem algo errado com o valor do aluguel. Favor verificar.");
    return "0";
  } else {
    if (NotZero === 0) {
      alert("Favor informar o valor do aluguel.");
      return 0;
    } else {
      if (valor == "" || valor == "R$ 0,00" || valor == "NaN") {
        alert("Favor informar o valor do aluguel.");
        return 0;
      } else {
        var valorNovo = void 0;
        var valorPreparado = valor.replaceAll(".", "");
        var valorPreparado2 = valorPreparado.replaceAll(",", ".");
        var valorPreparado3 = new Intl.NumberFormat("pt-BR", {
          minimumFractionDigits: 2,
        })
          .format(+valorPreparado2)
          .toString();
        var valorPreparado4 = valorPreparado3.replace(".", "");
        valorNovo = valorPreparado4.replaceAll(",", ".");
        return valorNovo;
      }
    }
  }
}
exports.formatarMoeda = formatarMoeda;
function exibirMoeda(valor) {
  var valorNovo;
  if (valor == undefined) {
    return "";
  } else {
    var valorPreparado = valor.replace(",", ".");
    valorNovo = new Intl.NumberFormat("pt-BR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })
      .format(+valorPreparado)
      .toString();
  }
  return valorNovo;
}
exports.exibirMoeda = exibirMoeda;
function formatarDataExibicao(props) {
  var dates1 = props === null || props === void 0 ? void 0 : props.split("T");
  if (dates1 !== undefined) {
    return dates1[0];
  }
  return "erro";
}
exports.formatarDataExibicao = formatarDataExibicao;
function exibirDataFuncaoDate(props) {
  var data = props;
  var dataFormatada =
    data.getDate() + "/" + (data.getMonth() + 1) + "/" + data.getFullYear();
  return dataFormatada;
}
exports.exibirDataFuncaoDate = exibirDataFuncaoDate;
function formatarData(props) {
  var _a;
  var dates1 = props === null || props === void 0 ? void 0 : props.split("T");
  if (dates1 !== undefined) {
    var dates2 =
      (_a = dates1[0]) === null || _a === void 0 ? void 0 : _a.split("-");
    return dates2[2] + "/" + dates2[1] + "/" + dates2[0];
  }
  return "erro";
}
exports.formatarData = formatarData;
function validateCelular(props) {
  var celular = props.split("");
  if (celular.length === 0) {
    return "Favor verificar o número celular!";
  } else {
    if (celular.length < 10) {
      return "Favor verificar o número celular!";
    } else {
      return false;
    }
  }
}
exports.validateCelular = validateCelular;
function validateCPF(props) {
  var CPF = props.split("");
  if (CPF.length !== 14) {
    return "Favor verificar o número do CPF!";
  } else {
    return false;
  }
}
exports.validateCPF = validateCPF;
function validateDataPeriodo(props) {
  var dates1 = props.split("-");
  var anoAtual = new Date().getFullYear();
  var mesAtual = new Date().getMonth() + 1;
  var diaAtual = new Date().getDate();
  var anoLimite = anoAtual + 20;
  if (+dates1[0] > anoLimite) {
    return "O multicotas não permite a inclusão de períodos maiores que 20 anos.";
  } else if (+dates1[0] < anoAtual) {
    return "Essa data já passou!";
  } else if (+dates1[0] == anoAtual && +dates1[1] < mesAtual) {
    return "Essa data já passou!";
  } else if (
    +dates1[0] == anoAtual &&
    +dates1[1] == mesAtual &&
    +dates1[2] < diaAtual
  ) {
    return "Essa data já passou!";
  } else {
    return "ok";
  }
}
exports.validateDataPeriodo = validateDataPeriodo;
function validateData(props) {
  var dates1 = props.split("");
  var dates2 = props.split("/");
  var anoAtual = new Date().getFullYear();
  var mesAtual = new Date().getMonth() + 1;
  var diaAtual = new Date().getDate();
  var anoLimite = anoAtual + 21;
  var qtdBarra = props.match(/\//g);
  if (qtdBarra === null) {
    return "O formato da data deve ser DD/MM/YYYY";
  } else if (qtdBarra.length != 2) {
    return "O formato da data deve ser DD/MM/YYYY";
  } else if (dates1.indexOf(" ") > -1) {
    return "Há espaços na data";
  } else if (dates2[0] > "31" || dates2[0].length > 2 || dates2[0].length < 2) {
    return "Tem algo errado no dia";
  } else if (dates2[1] > "12" || dates2[1].length > 2 || dates2[1].length < 2) {
    return "Tem algo errado no mês";
  } else if (dates2[2].length > 4 || dates2[2].length < 4) {
    return "Tem algo errado no ano";
  } else if (dates2[2] > anoLimite.toString()) {
    return "O multicotas limita períodos maiores de 20 anos.";
  } else if (dates2[2] < anoAtual.toString()) {
    return "Essa data já passou!";
  } else if (
    dates2[2] == anoAtual.toString() &&
    dates2[1] < mesAtual.toString()
  ) {
    return "Essa data já passou!";
  } else if (
    dates2[2] == anoAtual.toString() &&
    dates2[1] == mesAtual.toString() &&
    dates2[0] < diaAtual.toString()
  ) {
    return "Essa data já passou!";
  } else {
    return "ok";
  }
}
exports.validateData = validateData;
//confere se a segunda data passada na props é maior que a primeira se sim retorna true. formato datas dd/mm/yyyy
function validateDataCheckOutMaior(checkInProps, checkOutProps) {
  var checkInValidate = checkInProps.split("/");
  var checkOutValidate = checkOutProps.split("/");
  // console.log(
  //   checkInValidate[0],
  //   checkInValidate[1],
  //   checkInValidate[2],
  //   checkOutValidate[0],
  //   checkOutValidate[1],
  //   checkOutValidate[2]
  // );
  // console.log("------------------------");
  if (+checkInValidate[2] > +checkOutValidate[2]) {
    // console.log("1");
    return false;
  } else if (
    +checkInValidate[1] > +checkOutValidate[1] &&
    +checkInValidate[2] === +checkOutValidate[2]
  ) {
    // console.log("2");
    return false;
  } else if (
    +checkInValidate[0] >= +checkOutValidate[0] &&
    +checkInValidate[1] === +checkOutValidate[1]
  ) {
    // console.log("3");
    return false;
  } else {
    // console.log("4");
    return true;
  }
}
exports.validateDataCheckOutMaior = validateDataCheckOutMaior;
function validatePeriodoFracionado(
  checkInPeriodoProps,
  checkOutPeriodoProps,
  checkInPrimeiroPeriodoProps,
  checkOutPrimeiroPeriodoProps,
  checkInSegundoPeriodoProps,
  checkOutSegundoPeriodoProps
) {
  var date1 = "";
  var date2 = "";
  var date3 = "";
  var date4 = "";
  if (checkInPrimeiroPeriodoProps !== "") {
    date1 = new Date(
      formatarDataDayJs(checkInPrimeiroPeriodoProps)
    ).toLocaleDateString("pt-BR", { timeZone: "UTC" });
  }
  if (checkOutPrimeiroPeriodoProps !== "") {
    date2 = new Date(
      formatarDataDayJs(checkOutPrimeiroPeriodoProps)
    ).toLocaleDateString("pt-BR", { timeZone: "UTC" });
  }
  if (checkInSegundoPeriodoProps !== "") {
    date3 = new Date(
      formatarDataDayJs(checkInSegundoPeriodoProps)
    ).toLocaleDateString("pt-BR", { timeZone: "UTC" });
  }
  if (checkOutSegundoPeriodoProps !== "") {
    date4 = new Date(
      formatarDataDayJs(checkOutSegundoPeriodoProps)
    ).toLocaleDateString("pt-BR", { timeZone: "UTC" });
  }
  var hoje = new Date().toLocaleDateString("pt-BR", {
    timeZone: "UTC",
  });
  var dataCheckInPeriodo = new Date(
    formatarDataDayJs(checkInPeriodoProps)
  ).toLocaleDateString("pt-BR", { timeZone: "UTC" });
  var dataCheckOutPeriodo = new Date(
    formatarDataDayJs(checkOutPeriodoProps)
  ).toLocaleDateString("pt-BR", { timeZone: "UTC" });
  if (date1 === "") {
    return "Favor preencher o primeiro período.";
  } else {
    if (validateSegundaDataEMaior(date1, hoje)) {
      return "A data de check-in não pode ser anterior a data de hoje.";
    } else {
      if (validateSegundaDataEMaior(date1, dataCheckInPeriodo)) {
        return " A data de check-in não pode ser anterior a data de check-in do período fracionado.";
      } else {
        if (validateSegundaDataEMaior(dataCheckOutPeriodo, date2)) {
          return "A data de check-out não pode ser posterior a data de check-out do período fracionado.";
        } else {
          if (date1 === date2) {
            return " A data de check-in não pode ser igual a data de check-out.";
          } else {
            if (date3 === "") {
              return "ok";
            }
          }
        }
      }
    }
  }
  if (date3 !== "") {
    if (validateSegundaDataEMaior(date3, hoje)) {
      return "A data de check-in não pode ser anterior a data de hoje.";
    } else {
      if (validateSegundaDataEMaior(date3, dataCheckInPeriodo)) {
        return " A data de check-in não pode ser anterior a data de check-in do período fracionado.";
      } else {
        if (validateSegundaDataEMaior(dataCheckOutPeriodo, date4)) {
          return "A data de check-out não pode ser posterior a data de check-out do período fracionado.";
        } else {
          if (date3 === date4) {
            return " A data de check-in não pode ser igual a data de check-out.";
          } else {
            if (date2 !== "" && validateSegundaDataEMaior(date3, date2)) {
              return "Data de check-in do segundo período não pode ser anterior a data de check-out do primeiro período.";
            } else {
              return "ok";
            }
          }
        }
      }
    }
  }
}
exports.validatePeriodoFracionado = validatePeriodoFracionado;
function validateSegundaDataEMaior(checkInProps, checkOutProps) {
  var checkInValidate = checkInProps.split("/");
  var checkOutValidate = checkOutProps.split("/");
  if (+checkOutValidate[2] > +checkInValidate[2]) {
    return true;
  } else if (
    +checkOutValidate[1] > +checkInValidate[1] &&
    +checkInValidate[2] === +checkOutValidate[2]
  ) {
    return true;
  } else if (
    +checkOutValidate[0] > +checkInValidate[0] &&
    +checkInValidate[1] === +checkOutValidate[1] &&
    +checkInValidate[2] === +checkOutValidate[2]
  ) {
    return true;
  } else {
    return false;
  }
}
exports.validateSegundaDataEMaior = validateSegundaDataEMaior;
function adicionarDiasData(date, dias) {
  var dateNovo = new Date(formatarDataDayJs(date));
  dateNovo.setDate(dateNovo.getDate() + dias);
  return dateNovo.toLocaleDateString("pt-BR", {
    timeZone: "UTC",
  });
  // if (+checkOutValidate[2] > +checkInValidate[2]) {
  //   return true;
  // } else if (
  //   +checkOutValidate[1] > +checkInValidate[1] &&
  //   +checkInValidate[2] === +checkOutValidate[2]
  // ) {
  //   return true;
  // } else if (
  //   +checkOutValidate[0] > +checkInValidate[0] &&
  //   +checkInValidate[1] === +checkOutValidate[1] &&
  //   +checkInValidate[2] === +checkOutValidate[2]
  // ) {
  //   return true;
  // } else {
  //   return false;
  // }
}
exports.adicionarDiasData = adicionarDiasData;
function formatarDataDayJs(date) {
  var newDate = date.split();
  var day = "" + newDate[0][0] + newDate[0][1];
  var month = "" + newDate[0][3] + newDate[0][4];
  var year = "" + newDate[0][6] + newDate[0][7] + newDate[0][8] + newDate[0][9];
  // let day = +new Date(date).getDate();
  // let month = new Date(date).getMonth() + 1;
  // let year = +new Date(date).getFullYear();
  return year + "-" + month + "-" + day;
}
exports.formatarDataDayJs = formatarDataDayJs;
function logout() {
  localStorage.clear();
  document.location.href = "/login";
}
exports.logout = logout;
var Token = {
  AuthStr: "",
  id: "",
  nda: 0,
};
function validateToken() {
  var token = localStorage.getItem("accessToken");
  if (token) {
    var AuthStr = "Bearer " + token;
    var sub = Object(jwt_decode_1["default"](token)).sub;
    var now = new Date().getTime();
    var exp = Object(jwt_decode_1["default"](token)).exp * 1000;
    var nda = +Object(jwt_decode_1["default"](token)).nda;
    Token.id = sub;
    Token.AuthStr = AuthStr;
    Token.nda = nda;
    if (now > exp) {
      logout();
    } else {
      return Token;
    }
  } else {
    console.log("sem token");
  }
}
exports.validateToken = validateToken;
function validateTokenEmail() {
  var token = localStorage.getItem("accessToken");
  if (token) {
    var AuthStr = "Bearer " + token;
    var sub = Object(jwt_decode_1["default"](token)).sub;
    var now = new Date().getTime();
    var exp = Object(jwt_decode_1["default"](token)).exp * 1000;
    var nda = +Object(jwt_decode_1["default"](token)).nda;
    Token.id = sub;
    Token.AuthStr = AuthStr;
    Token.nda = nda;
    if (now > exp) {
      console.log("Vai para login");
    } else {
      return Token;
    }
  } else {
    console.log("token não encontrado");
  }
}
exports.validateTokenEmail = validateTokenEmail;
//enviar email
function enviarEmail(props) {
  return __awaiter(this, void 0, void 0, function () {
    var valorPrincipal,
      valor1Fracao,
      valor2Fracao,
      Token,
      _a,
      userId,
      tipoEmail,
      subjectEmail,
      bodyEmailAntes,
      bodyEmail,
      empreend,
      URL,
      formData,
      response,
      error_1,
      URL,
      response,
      error_2;
    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          valorPrincipal = props.valorPrincipal;
          valor1Fracao = props.valor1Fracao;
          valor2Fracao = props.valor2Fracao;
          Token = validateToken();
          _a = props.tipoEmail;
          switch (_a) {
            case 1:
              return [3 /*break*/, 1];
            case 2:
              return [3 /*break*/, 1];
            case 0:
              return [3 /*break*/, 8];
            case 3:
              return [3 /*break*/, 8];
            case 4:
              return [3 /*break*/, 8];
            case 5:
              return [3 /*break*/, 8];
            case 6:
              return [3 /*break*/, 8];
            case 7:
              return [3 /*break*/, 8];
            case 8:
              return [3 /*break*/, 8];
            case 9:
              return [3 /*break*/, 8];
            case 10:
              return [3 /*break*/, 8];
            case 11:
              return [3 /*break*/, 8];
            case 12:
              return [3 /*break*/, 8];
            case 13:
              return [3 /*break*/, 8];
            case 14:
              return [3 /*break*/, 8];
            case 15:
              return [3 /*break*/, 8];
          }
          return [3 /*break*/, 15];
        case 1:
          userId = props.userId;
          tipoEmail = +props.tipoEmail;
          subjectEmail = props.subjectEmail;
          bodyEmailAntes = props.bodyEmail;
          bodyEmail =
            bodyEmailAntes === null || bodyEmailAntes === void 0
              ? void 0
              : bodyEmailAntes.replaceAll("\n", "<br />");
          empreend = props.empreend;
          if (!Token) return [3 /*break*/, 6];
          URL = Globais.DOMINIOBACK + "/usuario/email";
          formData = {
            userId: userId,
            tipoEmail: tipoEmail,
            bodyEmail: bodyEmail,
            subjectEmail: subjectEmail,
            empreend: empreend,
          };
          _b.label = 2;
        case 2:
          _b.trys.push([2, 4, , 5]);
          return [
            4 /*yield*/,
            axios_1["default"].post(URL, formData, {
              headers: { Authorization: Token.AuthStr },
            }),
          ];
        case 3:
          response = _b.sent();
          if (response) {
            return [2 /*return*/, true];
          } else {
            return [2 /*return*/, false];
          }
          return [3 /*break*/, 5];
        case 4:
          error_1 = _b.sent();
          return [2 /*return*/, false];
        case 5:
          return [3 /*break*/, 7];
        case 6:
          document.location.href = "/";
          _b.label = 7;
        case 7:
          return [3 /*break*/, 15];
        case 8:
          if (!Token) return [3 /*break*/, 13];
          URL = Globais.DOMINIOBACK + "/periodo-usuario/email";
          _b.label = 9;
        case 9:
          _b.trys.push([9, 11, , 12]);
          return [
            4 /*yield*/,
            axios_1["default"].post(URL, props, {
              headers: { Authorization: Token.AuthStr },
            }),
          ];
        case 10:
          response = _b.sent();
          if (response) {
            console.log("deu certo");
            return [2 /*return*/, true];
          } else {
            console.log("não deu certo");
            return [2 /*return*/, false];
          }
          return [3 /*break*/, 12];
        case 11:
          error_2 = _b.sent();
          return [2 /*return*/, false];
        case 12:
          return [3 /*break*/, 14];
        case 13:
          document.location.href = "/";
          _b.label = 14;
        case 14:
          return [3 /*break*/, 15];
        case 15:
          return [2 /*return*/];
      }
    });
  });
}
exports.enviarEmail = enviarEmail;
function setCookie(nomeProps, valorProps) {
  localStorage.setItem(nomeProps, valorProps);
}
exports.setCookie = setCookie;
function getCookie(nomeProps) {
  var cookie = localStorage.getItem(nomeProps);
  if (cookie) {
    return cookie;
  } else {
    return "0";
  }
}
exports.getCookie = getCookie;
function qualSituacao(alugar, trocar, concluido, utilizar) {
  if (alugar === 1 && trocar === 1) {
    return "ALUGAR_TROCAR";
  } else {
    if (alugar === 1 && trocar === 0) {
      return "ALUGAR";
    } else {
      if (concluido === 1) {
        return "CONCLUIDO_PELO_PROPRIO";
      } else {
        if (utilizar === 1) {
          return "UTILIZADO";
        } else {
          console.log("Tem algo errado com os períodos");
        }
      }
    }
  }
}
exports.qualSituacao = qualSituacao;
function tratamentoValoresInput(props) {
  var valor = parseInt(props);
  if (isNaN(valor)) {
    return false;
  } else {
    return valor;
  }
}
exports.tratamentoValoresInput = tratamentoValoresInput;
function atualizarPeriodoUsuario(props) {
  return __awaiter(this, void 0, void 0, function () {
    var URL, Token, _a, caso, formData, responseAlterando, err_2;
    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          URL =
            Globais.DOMINIOBACK + "/periodo-usuario/" + props.periodoUsuario;
          Token = validateToken();
          if (!Token) return [3 /*break*/, 7];
          _a = props.caso;
          switch (_a) {
            case 1:
              return [3 /*break*/, 1];
            case 2:
              return [3 /*break*/, 1];
            case 3:
              return [3 /*break*/, 1];
            case 4:
              return [3 /*break*/, 1];
            case 5:
              return [3 /*break*/, 1];
            case 6:
              return [3 /*break*/, 1];
            case 7:
              return [3 /*break*/, 1];
            case 8:
              return [3 /*break*/, 1];
            case 9:
              return [3 /*break*/, 1];
          }
          return [3 /*break*/, 6];
        case 1:
          (caso = props.caso), (formData = __rest(props, ["caso"]));
          _b.label = 2;
        case 2:
          _b.trys.push([2, 4, , 5]);
          return [
            4 /*yield*/,
            axios_1["default"].put(URL, formData, {
              headers: { Authorization: Token.AuthStr },
            }),
          ];
        case 3:
          responseAlterando = _b.sent();
          if (responseAlterando) {
            return [2 /*return*/, 1];
          } else {
            console.log("deu algo errado");
          }
          return [3 /*break*/, 5];
        case 4:
          err_2 = _b.sent();
          if (err_2.response.status == 500) {
            alert("Há algo de errado. Por favor, entre em contato conosco.");
          }
          return [2 /*return*/, 2];
        case 5:
          return [3 /*break*/, 6];
        case 6:
          return [3 /*break*/, 8];
        case 7:
          console.log("sem token");
          _b.label = 8;
        case 8:
          return [2 /*return*/];
      }
    });
  });
}
exports.atualizarPeriodoUsuario = atualizarPeriodoUsuario;
//função que devolve fase atual do período do usuário. Usado para sugestões de valores, para evitar que uma sugetsão seja enviadas várias vezes a um propritário que já aceitou ou recusou a sugestão.
// as fases definem também a distancia do período em relação ao checkin e consequentemente o percentual de desconto, se houver,  de acordo com a estratégia de preço.
function definirFasePeriodoUsuario(props) {
  return __awaiter(this, void 0, void 0, function () {
    var confirmando, nCheckIn, diferenca, novaFase, hoje;
    return __generator(this, function (_a) {
      confirmando = props.confirmando;
      if (props.checkIn) {
        nCheckIn = props.checkIn;
      } else {
        if (props.periodoId) {
          nCheckIn = "24/02/2024";
        }
      }
      hoje = exibirDataFuncaoDate(new Date());
      if (confirmando) {
        diferenca = CalcularDiferencaDias(
          AlterarFormatoData(nCheckIn),
          AlterarFormatoData(hoje)
        );
      } else {
        diferenca = CalcularDiferencaDias(
          AlterarFormatoData(formatarData(nCheckIn)),
          AlterarFormatoData(hoje)
        );
      }
      if (diferenca < 60) {
        novaFase = "FASE5";
      } else {
        if (diferenca < 90) {
          novaFase = "FASE4";
        } else {
          if (diferenca < 120) {
            novaFase = "FASE3";
          } else {
            if (diferenca < 150) {
              novaFase = "FASE2";
            } else {
              if (diferenca < 180) {
                novaFase = "FASE1";
              } else {
                if (diferenca >= 180) {
                  novaFase = "FASE0";
                } else {
                  console.log("não foi possível definir a fase");
                }
              }
            }
          }
        }
      }
      return [2 /*return*/, novaFase];
    });
  });
}
exports.definirFasePeriodoUsuario = definirFasePeriodoUsuario;
